
<script setup> 
import { ref, toRefs, onMounted } from "vue"
import { useStripe } from '@/hooks/useStripe'

const props = defineProps({
	stripeError: { type: String },
})

const { stripeError } = toRefs(props)

const cardElement = ref(null)

const { initializeStripe } = useStripe()

onMounted(() => {
	// Ensure that the Stripe.js script is loaded
	if (!window.Stripe) {
		const script = document.createElement('script')
		script.src = 'https://js.stripe.com/v3/'
		script.async = true
		script.onload = () => {
			initializeStripe(cardElement.value)
		};
		document.head.appendChild(script)
	} else {
		initializeStripe(cardElement.value)
	}
})
</script>

<template>
	<section>
		<form id="payment-form">
			<div id="card-element" ref="cardElement"></div>
			<!-- <button id="submit" @click="handlePayment">
				<div class="spinner hidden" id="spinner"></div>
				<span id="button-text">Submit Payment</span>
			</button> -->
			<p id="card-error" role="alert">{{ stripeError }}</p>
			<p class="result-message hidden">
				Payment succeeded, see the result in your
				<a href="" target="_blank">Stripe dashboard.</a> Refresh the page to pay
				again.
			</p>
		</form>
	</section>
</template>

<style lang="postcss" scoped>
form {
	@apply w-full flex-1
  /* width: 30vw; */
  /* min-width: 500px; */
}
input {
	@apply rounded mb-[6px] p-3 border border-[rgba(50,50,93,0.1)] h-11 bg-white
}

#card-element {
  @apply rounded-lg p-3 border border-[rgba(50,50,93,0.1)] h-11 bg-white
}

#card-error {
	@apply text-red-700 text-left font-[13px] leading-[17px] my-3
}
</style>